import tw, { styled } from 'twin.macro'

import { Text4xlLeading10FontSemiboldBlueGray900 } from '@flowwai-frontend/shared/style-guide'
import { isMobile } from '@flowwai-frontend/shared/utils/web'
export const YourProjectsLoadingWrapper = styled.div`
   display: flex;
   justify-content: flex-start;
   flex-wrap: wrap;
   margin-top: 50px;
`
export const ProjectLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   --bg-opacity: 1;
   background-color: rgba(255, 255, 255, var(--bg-opacity));
   border-style: solid;
   border-width: 1px;
   --border-opacity: 1;
   border-color: rgba(228, 231, 235, var(--border-opacity));
   border-radius: 12px;
   padding: 24px;
   cursor: pointer;
   width: 416px;
   height: 184px;
   margin: 8px 12px 8px 4px;
`
export const ProjectPrefixAndDisplayNameLoadingWrapper = styled.div`
   display: flex;
   align-items: center;
`
export const ContentLoadingWrapper = styled.div`
   margin-top: 20px;
`

export const IconAndTextWrapper = styled.div`
   display: flex;
   align-items: center;
   margin-bottom: 8px;
`
export const ProjectsListLoadingWrapper = styled.div`
   & .projects-list-loading-wrapper {
      ${tw`w-full h-full`}
   }
   ${tw`w-full h-full overflow-y-auto p-8 shadow-inner`}
   ${tw`bg-blue-gray-50 flex flex-col`};
   padding: 28px 0px 0px 32px;
`
export const ProjectsRouteHeader = styled.div`
   ${tw`flex flex-row justify-between`}
`
export const YourProjectsTitleLoader = styled(
   Text4xlLeading10FontSemiboldBlueGray900
)`
   ${tw`leading-0.83`};

   ${isMobile()} {
      ${tw`block leading-1.2`}
   }
`

export const YourProjectsRouteLoadingWrapper = styled.div`
   ${tw`h-full overflow-hidden`};
`
